
import { setWorkingHours, setAppointments, setFacilities, setStaff } from '../slices/calendarSlice';
import { getAuthToken } from '../../utils/authUtils';


// Helper function to get API base URL
function getApiBaseUrl() {
  return process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
}

// Helper function to convert timestamps
function convertTimestamps(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  const newObj = Array.isArray(obj) ? [] : {};
  for (const key in obj) {
    if (obj[key] && typeof obj[key].toDate === 'function') {
      newObj[key] = obj[key].toDate().toISOString();
    } else if (typeof obj[key] === 'object') {
      newObj[key] = convertTimestamps(obj[key]);
    } else {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

export const fetchWorkingHours = (facilityIds, staffIds) => async dispatch => {
  if (!facilityIds.length || !staffIds.length) return;
  try {
    const params = new URLSearchParams();
    params.append('facilityIds', facilityIds.slice(0, 10).join(','));
    params.append('staffIds', staffIds.slice(0, 10).join(','));

    const token = await getAuthToken();
    const response = await fetch(
      `${getApiBaseUrl()}/internal/working-hours?${params}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch working hours');
    }

    const result = await response.json();
    const workingHours = result.workingHours.map(item => convertTimestamps(item));
    dispatch(setWorkingHours(workingHours));
  } catch (error) {
    console.error('Error fetching working hours:', error);
    dispatch(setWorkingHours([]));
  }
};

export const fetchAppointments = (facilityIds, staffIds) => async dispatch => {
  if (!facilityIds.length || !staffIds.length) return;
  try {
    const params = new URLSearchParams();
    if (facilityIds.length > 0) {
      params.append('facilityId', facilityIds[0]); // Use first facility for now, can be enhanced later
    }
    if (staffIds.length > 0) {
      params.append('providerId', staffIds[0]); // Use first staff member for now, can be enhanced later
    }

    const token = await getAuthToken();
    const response = await fetch(
      `${getApiBaseUrl()}/internal/appointments?${params}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch appointments');
    }

    const result = await response.json();
    const appointments = result.appointments.map(item => convertTimestamps(item));
    dispatch(setAppointments(appointments));
  } catch (error) {
    console.error('Error fetching appointments:', error);
    dispatch(setAppointments([]));
  }
};

export const fetchFacilities = () => async dispatch => {
  try {
    const token = await getAuthToken();
    const response = await fetch(
      `${getApiBaseUrl()}/facility/facilities`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch facilities');
    }

    const result = await response.json();
    const facilities = result.facilities.map(item => convertTimestamps(item));
    dispatch(setFacilities(facilities));
  } catch (error) {
    console.error('Error fetching facilities:', error);
    dispatch(setFacilities([]));
  }
};

export const fetchStaff = () => async dispatch => {
  try {
    const token = await getAuthToken();
    const response = await fetch(
      `${getApiBaseUrl()}/internal/staff`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch staff');
    }

    const result = await response.json();
    const staff = result.staff.map(item => convertTimestamps(item));
    dispatch(setStaff(staff));
  } catch (error) {
    console.error('Error fetching staff:', error);
    dispatch(setStaff([]));
  }
};

export const saveWorkingHour = (workingHour, facilityIds, staffIds) => async dispatch => {
  try {
    const token = await getAuthToken();
    const response = await fetch(
      `${getApiBaseUrl()}/internal/working-hours`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(workingHour)
      }
    );

    if (!response.ok) {
      throw new Error('Failed to save working hour');
    }

    // Refresh working hours after save
    dispatch(fetchWorkingHours(facilityIds, staffIds));
  } catch (error) {
    console.error('Error saving working hour:', error);
  }
}; 